module.exports = __webpack_public_path__ + "img/Syrian Arab Republic.2720eec5.gif";